import { GridRenderCellParams } from '@mui/x-data-grid';
import React from 'react';
import { Typography } from '@mui/material';

export const GridCellYesNo = (params: GridRenderCellParams) => {
  const cellValue = params.row?.verifiedEMPVReferenceCount > 0 ? `Yes(${params.row?.verifiedEMPVReferenceCount})` : 'No'
  return (
    <Typography
      component="span"
      sx={theme => ({
        color: params.row?.verifiedEMPVReferenceCount > 0 ? theme.palette.system.irishGreen
             : theme.palette.system.darkRed,
      })}
    >
      {cellValue}
    </Typography>
  );
};
